/** Default contact for general support and account assistance. */
export const DEVELOPER_CONTACT_EMAIL = 'developer@ascendhealthgroup.com.au'

/** Privacy-inquiry contact per the AHG Privacy Policy (access, correction, complaints). */
export const PRIVACY_CONTACT_EMAIL = 'developer@ascendh.com.au'
